<template>
	<span>
		<el-tag
			class="usage"
			:type="availableCredit.executionsBalance === 0 ? 'danger' : 'warning'"
			v-loading="loading"
			v-if="usageStrategy"
		>
			<span v-html="usageString"></span>
		</el-tag>
	</span>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	computed: {
		...mapGetters(["returnChangesToUsageCredit"]),
	},
	watch: {
		returnChangesToUsageCredit: async function () {
			await this.getCreditsState();
		},
	},
	data() {
		return {
			availableCredit: { executionsBalance: 0, workflowsBalance: 0 },
			usageStrategy: null,
			usageString: "",
			loading: true,
		};
	},
	async mounted() {
		await this.getCreditsState();
	},
	methods: {
		async getCreditsState() {
			const result = await this.httpHelper("RUNTIME", "GET", "usage/returnUsageCreditForOrg", {});
			if (result.response) {
				this.usageStrategy = result.response.usageStrategy;
				this.availableCredit = result.response.availableCredit;
				
				// Commit wallet balance to global store as a number (handles manual string updates in DB)
				const walletVal = result.response.walletBalanceGBP !== undefined ? Number(result.response.walletBalanceGBP) : null;
				this.$store.commit("setWalletBalance", walletVal);
				
				if (this.usageStrategy === "workflows") {
					this.usageString = `New workflows available: <b>${this.availableCredit.workflowsBalance}</b>`;
				}
				if (this.usageStrategy === "executions") {
					this.usageString = `Available workflow executions: <b>${this.availableCredit.executionsBalance}</b>`;
				}
				if (this.usageStrategy === "executions&Workflows") {
					this.usageString = `Available workflow executions: <b>${this.availableCredit.executionsBalance}</b> - Additional workflows available: <b>${this.availableCredit.workflowsBalance}</b>`;
				}
			}
			setTimeout(() => {
				this.loading = false;
			}, 500);
		},
	},
};
</script>

<style scoped>
.usage {
	color: #210f3c !important;
	font-size: 14px;
}
</style>
